import { Visibility } from 'semantic-ui-react';

// This function is directly taken from https://github.com/Semantic-Org/Semantic-UI-React/blob/master/src/lib/normalizeOffset.js
const normalizeOffset = value =>
	typeof value === 'number' || typeof value === 'string'
		? [value, value]
		: value;

/**
 * This an override of the normal Visibility component from SemanticUI. This component takes in
 * count the `context` parameter to calculate and define if the top or bottom has been passed or
 * are visible (among other measurements), in other words, it calculates every measurement relative
 * to the `context` given
 */

class RelativeVisibility extends Visibility {
	computeCalculations() {
		const calculations = super.computeCalculations();

		const { offset, context } = this.props;

		const {
			height,
			top: childTop,
			bottom: childBottom,
		} = this.ref.getBoundingClientRect();
		const {
			top: contextTop,
			bottom: contextBottom,
		} = context.getBoundingClientRect();
		let [topOffset, bottomOffset] = normalizeOffset(offset).map(
			v => v + contextTop
		);

		const topPassed = childTop < topOffset;
		const bottomPassed = childBottom < bottomOffset;
		const pixelsPassed = bottomPassed ? 0 : contextTop - childTop;
		const percentagePassed = pixelsPassed / height;

		const bottomVisible =
			childBottom >= bottomOffset &&
			Math.round(childBottom) <= Math.round(contextBottom);
		const topVisible = childTop >= topOffset && childTop <= contextTop;

		const fits = topVisible && bottomVisible;
		const passing = topPassed && !bottomPassed;

		const onScreen = (topVisible || topPassed) && !bottomPassed;
		const offScreen = !onScreen;

		return {
			...calculations,
			topPassed,
			bottomPassed,
			bottomVisible,
			topVisible,
			pixelsPassed,
			percentagePassed,
			fits,
			passing,
			onScreen,
			offScreen,
		};
	}
}

export default RelativeVisibility;
